import { render, staticRenderFns } from "./LaboratoryServices.vue?vue&type=template&id=77da66cc&scoped=true&"
import script from "./LaboratoryServices.vue?vue&type=script&lang=js&"
export * from "./LaboratoryServices.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryServices.vue?vue&type=style&index=0&id=77da66cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da66cc",
  null
  
)

export default component.exports